import { RenderImageProps } from '@v2/pages/machines/common/types/props';
import React from 'react';
import Image from '@components/common/ImageOverlay';

const RenderImage = React.memo(
  ({ uploadedImage, imageLink, imageRandomHash, rotationAngle, C, borderRadius }: RenderImageProps) => {
    const isDataUrl = typeof imageLink === 'string' && imageLink.startsWith('data:');
    const uri = isDataUrl ? imageLink : (imageLink + `&dummy=${imageRandomHash}` || ' ');
    return (
      <Image
        C={C}
        rotate={rotationAngle}
        source={uploadedImage ? uploadedImage : { uri }}
        resizeMode="contain"
        style={{ width: '100%', height: '100%' }}
        borderRadius={borderRadius}
      />
    );
  },
  (prev, next) => {
    return prev.imageLink === next.imageLink && prev.imageRandomHash === next.imageRandomHash && prev.rotationAngle === next.rotationAngle && prev.borderRadius === next.borderRadius;
  }
);

export { RenderImage };
